import React from "react";
import Navbar from "../components/FrontPages/Common/Navbar";
import AboutUs from "../components/FrontPages/Common/AboutUs";
import Footer from "../components/FrontPages/Common/Footer";
import FaqContent from "../components/FrontPages/Common/FaqContent";
import OurTeam from "../components/FrontPages/Common/OurTeam";


const About = () => {
    return (
        <>
            <div className="fp-wrapper">
                <Navbar />
                <AboutUs />
                <OurTeam />
                <FaqContent />
                <Footer />
            </div>
        </>
    );
};

export default About;
